module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/venezia.7df15b4eb6a2769f1a0f0e73fde79148.jpg";